import { render, staticRenderFns } from "./InboxList.vue?vue&type=template&id=098f01cb&scoped=true&"
import script from "./InboxList.vue?vue&type=script&lang=js&"
export * from "./InboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f01cb",
  null
  
)

export default component.exports